export default function ($rootScope) {
    return {
        restrict: 'A',
        scope: {},
        link: function (scope, elem) {
            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                let fromClassnames = angular.isDefined(fromState.data) && angular.isDefined(fromState.data.class_name) ? fromState.data.class_name : null;
                let toClassnames = angular.isDefined(toState.data) && angular.isDefined(toState.data.class_name) ? toState.data.class_name : null;

                // don't do anything if they are the same
                if (fromClassnames != toClassnames) {
                    if (fromClassnames) {
                        elem.removeClass(fromClassnames);
                    }

                    if (toClassnames) {
                        elem.addClass(toClassnames);
                    }
                }
            });
        }
    }
};


/** WEBPACK FOOTER **
 ** ./js/directives/class_name.js
 **/